/**
 * Opens LiveChat when the page is loaded with ?openChat=1.
 * Used by customer-account UI links that cannot call LC_API in their sandbox.
 */
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('openChat') !== '1') return;
  } catch (e) {
    return;
  }

  function openChat() {
    if (window.LC_API && typeof window.LC_API.open_chat_window === 'function') {
      window.LC_API.open_chat_window();
      return true;
    }
    return false;
  }

  if (openChat()) return;

  window.LC_API = window.LC_API || {};
  var previousAfterLoad = window.LC_API.on_after_load;
  window.LC_API.on_after_load = function () {
    if (typeof previousAfterLoad === 'function') previousAfterLoad();
    openChat();
  };

  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;
    if (openChat() || attempts >= 40) clearInterval(timer);
  }, 250);
})();
